'use strict';

const handleAppleClaimLocationsSocket = (window, listingsManagerUrl, site, pmtElmService) => {
	const io = window.io;
	function socketInit() {
		const baseUrl = listingsManagerUrl
			.replace('https', 'wss')
			.replace('http', 'ws')
			.replace('/listings/', '/');
		const socketUrl = baseUrl + 'info';

		return io.connect(socketUrl, {
			query: 'site=' + site,
			transports: ['websocket'],
			path: '/listings/socket.io'
		});
	}
	const socket = socketInit();
	socket.on('appleClaimLocations', msg => {
		pmtElmService.sendData(
			'Tasks.Apple.Claim.Main',
			`in_Tasks_Apple_Claim_Main_networkStatus`,
			msg.msg
		);
	});
	socket.on('appleSyncLocations', msg => {
		pmtElmService.sendData(
			'Tasks.Apple.Claim.Main',
			`in_Tasks_Apple_Claim_Main_syncLocations`,
			msg.msg.lastRun
		);
	});
	socket.on('appleRepublishLocations', msg => {
		pmtElmService.sendData(
			'Tasks.Apple.Claim.Main',
			`in_Tasks_Apple_Claim_Main_republishLocations`,
			msg.msg.lastRun
		);
	});
};

module.exports = { handleAppleClaimLocationsSocket };
